module.exports = __webpack_public_path__ + "media/20191009144140753.f448ea9e.mp4";